import Cookies from 'js-cookie'

export function getCookie(name) {
  return Cookies.get(name)
}

export function setCookie(name, token) {
  return Cookies.set(name, token)
}

export function removeCookie(name) {
  return Cookies.remove(name)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js